// src/App.js
import React, { useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext.js';
import PreCountScreen from './screens/PreCount/PreCountScreen.js';
import RollsWrittenTip from './screens/PreCount/RollsWrittenTip.js';
import POSSummaryScreen from './screens/POS/POSSummaryScreen.js';
import VendorPayoutScreen from './screens/Vendor/VendorPayoutScreen.js';
import TipBucketScreen from './screens/TipBucket/TipBucketScreen.js';
import TipRemovalScreen from './screens/TipRemoval/TipRemovalScreen.js';
import DrawerCoinScreen from './screens/DrawerCoin/DrawerCoinScreen.js';
import BillCountScreen from './screens/BillCountScreen.js';
import ReconcileSummary from './screens/Reconcile/ReconcileSummary.js';
import ReconcileAdjustSalesTax from './screens/Reconcile/ReconcileAdjustSalesTax.js';
import ReconcileVariance from './screens/Reconcile/ReconcileVariance.js';
import DepositInstructionsScreen from './screens/DepositInstructions/DepositInstructionsScreen.js';
import FinalSummaryScreen from './screens/Final/FinalSummaryScreen.js';
import AdminScreen from './screens/AdminScreen.js';
import LoginScreen from './screens/Auth/LoginScreen.js';

// Keep stepScreens outside component so it doesn't recreate on each render
const stepScreens = [
  PreCountScreen,
  RollsWrittenTip,
  POSSummaryScreen,
  VendorPayoutScreen,
  TipBucketScreen,
  TipRemovalScreen,
  DrawerCoinScreen,
  BillCountScreen,
  ReconcileSummary,
  ReconcileAdjustSalesTax,
  ReconcileVariance,  
  DepositInstructionsScreen,
  FinalSummaryScreen
];

export default function App() {
  // Hooks must always be at the top
  const { user } = useAuth();
  const [step, setStep] = useState(1);

  const goNext = () => setStep(s => Math.min(s + 1, stepScreens.length));
  const goBack = () => setStep(s => Math.max(1, s - 1));

  // Unauthenticated -> Login
  if (!user) {
    return <LoginScreen />;
  }

  // Admin user -> AdminScreen
  if (user.role === 'admin') {
    return <AdminScreen />;
  }

  // Authenticated non-admin -> step flow
  const Current = stepScreens[step - 1];
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <Current onNext={goNext} onBack={goBack} />
    </div>
  );
}
